import gql from 'graphql-tag'

export const SEND_CANCEL_SURGERY_EMAIL = gql`
mutation SendCancelSurgeryEmail{
  sendCancelSurgeryEmail
}
`



// WEBPACK FOOTER //
// ./src/mutations/SEND_CANCEL_SURGERY_EMAIL.ts